/** 3. PENNYSAVER — aged-newspaper skin. Free: review voice preset (single-select chips).
 * Supporter: custom review voice (free-text). */
import { useEffect, useState } from 'react';
import type { Preferences } from '@pghbites/shared';
import { Chips } from './Chips.js';
import { ExampleBlock } from './ExampleBlock.js';
import { REVIEW_VOICE_OPTIONS, EXAMPLE_CUSTOM_VOICE } from './options.js';

interface PennysaverProps {
  preferences: Preferences;
  isSupporter: boolean;
  onSetReviewVoice: (value: string) => void;
  onSetCustomVoice: (value: string) => void;
}

export function PennysaverWindow({ preferences, isSupporter, onSetReviewVoice, onSetCustomVoice }: PennysaverProps) {
  const [custom, setCustom] = useState(preferences.custom_review_voice);
  useEffect(() => { setCustom(preferences.custom_review_voice); }, [preferences.custom_review_voice]);

  return (
    <div className="sec">
      <div className="seclabel"><span className="dot">📰</span> Pennysaver carries your reviewer voice</div>
      <div className="news">
        <div className="mast">THE PENNYSAVER</div>
        <div className="dek"><span>Pittsburgh Edition</span><span>Your Review Voice</span></div>
        <p className="sub">How your reviews read when they hit the page.</p>
        <Chips
          options={REVIEW_VOICE_OPTIONS}
          selected={preferences.review_voice ? [preferences.review_voice] : []}
          single ariaLabel="review voice preset"
          onToggle={(v) => onSetReviewVoice(v === preferences.review_voice ? '' : v)}
        />

        {isSupporter ? (
          <div className="custom">
            <label htmlFor="penny-custom">Custom voice (your words)</label>
            <input
              id="penny-custom" type="text" value={custom} placeholder={`e.g. ${EXAMPLE_CUSTOM_VOICE}`}
              onChange={(e) => setCustom(e.target.value)}
              onBlur={() => custom !== preferences.custom_review_voice && onSetCustomVoice(custom)}
            />
          </div>
        ) : (
          <ExampleBlock hint={<>🔒 <b>Supporters</b> get a custom review voice in their own words.</>}>
            <div className="custom">Custom voice: &ldquo;{EXAMPLE_CUSTOM_VOICE}&rdquo;</div>
          </ExampleBlock>
        )}
      </div>
      <div className="hint">pick a voice →</div>
    </div>
  );
}
